// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  createContainerRegistryManagement,
  type ContainerRegistryManagementContext,
  type ContainerRegistryManagementClientOptionalParams,
} from "./containerRegistryManagementContext.js";
